import { createFileRoute } from "@tanstack/react-router";

import { Planning } from "~/components/engagement/planning/planning";

export const Route = createFileRoute(
  "/_user/my-coaching/clients/programs/$engagementId/coaching-goals-and-outcomes",
)({
  staticData: { title: "Coaching goals" },
  component: CoachingGoalsPage,
});

function CoachingGoalsPage() {
  const { engagementId } = Route.useParams();

  return <Planning engagementId={engagementId} />;
}
